import React from 'react';
import PropTypes from 'prop-types';

import { useAuth } from '@/shared/contexts/AuthContext';

const PublicRoutes = ({ children }) => {
    const { loading } = useAuth();

    if (loading) return <div>Loading...</div>;

    return children;
};

PublicRoutes.propTypes = {
    children: PropTypes.node.isRequired,
};

export default PublicRoutes;
